export default __webpack_public_path__ + "static/media/ass_sec_gen_img.12a4b06a.jpg";